import React, { useState, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
// Importa tus componentes reutilizables aquí
import { RiHomeOfficeFill } from 'react-icons/ri';
import { BsBuilding,BsCalendar2Check, BsSearch, BsClock  } from 'react-icons/bs';
import { TbZoomReset } from 'react-icons/tb';
import DataTable from '../../../../components/ui/DataTable';
import Spinner from "../../../../components/Spinner";
import { formatCurrency, getUser, sqlDateFormat } from '../../../../utils/Common';
import { useOffice } from '../../../../hooks/useOffice';
import SelectSearch from '../../../../components/ui/SelectSearch';
import NotifyC from '../../../../components/Notifications';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimeRangePicker from 'rsuite/TimeRangePicker';
import CustomProvider  from 'rsuite/CustomProvider';
import * as locales from 'rsuite/locales';
import 'rsuite/TimeRangePicker/styles/index.css';
import './index.css'; 

const SearchCommissionReport = () => {
  const user = getUser();
  const { getPostOfficeStatus, getListProvinces, searchReportCT } = useOffice();
  const { handleSubmit, reset } = useForm();
  const [filterType, setFilterType] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');

  const [filterTypeList, setFilterTypeList] = useState(
    user.roleId >= 7 
      ? [
          { value: 1, label: 'Nacional' },
          { value: 2, label: 'Provincia' },
          { value: 3, label: 'Estafeta' }
        ]
      : [
          { value: 2, label: 'Provincia' },
          { value: 3, label: 'Estafeta' }
        ]
  );

  const [postOffices, setPostOffices] = useState([]);
  const [listOffice, setListOffice] = useState([]);
  const [officeSelected, setOfficeSelected] = useState("");

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [time, setTime] = useState([]);
  const [start, end] = Array.isArray(time) ? time : [new Date(), new Date()];
  const data = Object.keys(locales).map(key => ({
      key: key.replace(/([a-z]{2})([A-Z]{2})/, '$1-$2'),
      value: locales[key]
    }));
  const [localeKey, setLocaleKey] = useState('es-ES');
  const locale = data.find(item => item.key === localeKey);


  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
 
  // Lógica de visibilidad de filtros para roles 2, 3, 4, 5, 6
  const showOfficeFilter = user.roleId === 2 || user.roleId === 3 || (user.roleId >= 4 && filterType === 3);
  const showProvinceFilter = (user.roleId >= 4 && filterType === 2) || (user.roleId >= 7 && filterType === 2);
  const showFilterTypeSelector = user.roleId >= 4;
 
const handleReset = () => {
  reset();
  setDateRange([null, null]);
  setTime([]);
  setResults([]);
  setHasSearched(false);

  if ([2,3].includes(user.roleId)) {
    setOfficeSelected('');
  } else if ([4,5,6].includes(user.roleId)) {
    setSelectedProvince('');
    setOfficeSelected('');
    setFilterType(2);
  } else if (user.roleId >= 7) {
    setOfficeSelected('');
    setSelectedProvince('');
    setFilterType(1);
  }
};

  const formatTime = (date) => {
    
    if (!(date instanceof Date) || isNaN(date)) {
        return null; 
    }
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const validateFilters = () => {
    if (filterType === 3) {
      if (!officeSelected) {
        NotifyC.error("Por favor, selecciona una estafeta.");
        return false;
      }
      if (!startDate || !endDate) {
        NotifyC.error("Por favor, selecciona un rango de fechas.");
        return false;
      }
    }
    if (filterType === 2) {
      if (!selectedProvince) {
        NotifyC.error("Por favor, selecciona una provincia.");
        return false;
      }
      if (!startDate || !endDate) {
        NotifyC.error("Por favor, selecciona un rango de fechas.");
        return false;
      }
    }
    if (filterType === 1) {
      if (!startDate || !endDate) {
        NotifyC.error("Por favor, selecciona un rango de fechas.");
        return false;
      }
    }
    if ((start || end) && (!startDate || !endDate)) {
      NotifyC.error("No puedes buscar por rango de horas sin seleccionar primero un rango de fechas.");
      return false;
    }
    return true;
  };

  const canSearch = () => {
    if (filterType === 3) {
      if (!officeSelected) return false;
      if (!startDate || !endDate) return false;
    }
    if (filterType === 2) {
      if (!selectedProvince) return false;
      if (!startDate || !endDate) return false;
    }
    if (filterType === 1) {
      if (!startDate || !endDate) return false;
    }
    if ((start || end) && (!startDate || !endDate)) return false;
    return true;
  };

  const handleOnSubmit = async () => {
    if (!validateFilters()) return;
    setIsLoading(true);
    setHasSearched(true);
    const dataToSend = {
      IdPostOffice: officeSelected || null,
      IdProvincia: selectedProvince || null,
      type: '3,4',
      fechaDesde: startDate ? startDate : null, 
      fechaHasta: endDate ? endDate : null, 
      horaDesde: start ? formatTime(start): null,
      horaHasta: end? formatTime(end) : null,
    };
    const abortController = new AbortController();
    const response = await searchReportCT(abortController.signal, dataToSend);
    if (response?.payload?.length > 0) {
        setResults(response.payload);
        NotifyC.success(`Reporte de comisiones y transmisiones encontrados.`);
        setIsLoading(false);
        setHasSearched(true);
    } else {
        setResults([]);
        NotifyC.error("No se encontraron resultados");
        setIsLoading(false);
        setHasSearched(false);
    }
  };

  const handleGetListProvinces = async () => {
    const abortController = new AbortController();
    try {
        const response = await getListProvinces(abortController.signal);
        if (response.length > 0) {
            setProvinces(response);
        } else {
            NotifyC.error("Error al obtener las provincias");
        }
    } catch (error) {
        NotifyC.error("Error al obtener las provincias");
    }
  };

  const handleGetListOffices = async () => {
    try {
    const abortController = new AbortController();
    const response = await getPostOfficeStatus(abortController.signal);
   
    if (response?.payload?.length > 0) {
        setListOffice(response.payload);
    } else {
        setListOffice([]);
        NotifyC.error("No se pudo obtener la lista de estafetas");
    }
    }catch (error) {
    console.error(error);
    }
  };

 const handleSelect = (name, value) => {
    if (name === "office") {
        setOfficeSelected(value);

    }
    if (name === "filterType") {
        setFilterType(value);
        setResults([]); 
        setHasSearched(false);
        
        
    }
    if (name === "province") {
        setSelectedProvince(value);
      
    }
 };

 const renderOriginSelectOffice = (nameInput, title) => { 
    const options = listOffice.map(office => ({
    value: office.IdSucursal || "",
    label: (office.NombreProvincia + ' - ' + office.NombreSucursal) || ""
    }));
    return (
        <div className="col-12 col-md-6 input-group text-left mb-3">
            <div className="d-flex w-100">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black", borderRadius: "6px 0 0 6px" }}>
                        <BsBuilding className="mr-2" size={18} /> {title}
                    </span>
                </div>
                <SelectSearch options={options} nameInput={nameInput} setValue={handleSelect} value={officeSelected} />
            </div>
        </div>
    );
  };

  const columns = useMemo(() => {
    if (filterType === 3) {
      return [
        { Header: "Fecha", accessor: "FechaRegistro", Cell: ({ value }) => sqlDateFormat(value, "date", true), exportable: true },
        { Header: "Estafeta", accessor: "NombreSucursal", exportable: true },
        { Header: "Comisión", accessor: "TotalMontoFee", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Transmisión", accessor: "TotalMontoTransmision", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Total", accessor: "Monto", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
      ];
    } else if (filterType === 2) {
      return [
        { Header: "Provincia", accessor: "NombreProvincia", exportable: true },
        { Header: "Estafeta", accessor: "NombreSucursal", exportable: true },
        { Header: "Comisión", accessor: "TotalMontoFee", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Transmisión", accessor: "TotalMontoTransmision", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Total", accessor: "Monto", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
      ];
    } else if (filterType === 1) {
      return [
        { Header: "Provincia", accessor: "NombreProvincia", exportable: true },
        { Header: "Comisión", accessor: "TotalMontoFee", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Transmisión", accessor: "TotalMontoTransmision", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
        { Header: "Total", accessor: "Monto", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
      ];
    }
    return [
      { Header: "Provincia", accessor: "NombreProvincia", exportable: true },
      { Header: "Estafeta", accessor: "NombreSucursal", exportable: true },
      { Header: "Comisión", accessor: "TotalMontoFee", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
      { Header: "Transmisión", accessor: "TotalMontoTransmision", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
      { Header: "Total", accessor: "Monto", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
    ];
  }, [filterType]); 

  const getReportHeaderText = () => {
    const fechaDesde = sqlDateFormat(startDate, "date", true);
    const fechaHasta = sqlDateFormat(endDate, "date", true);

    let horas = '';
    if (start && end) {
      horas = ` ENTRE LAS HORAS: ${sqlDateFormat(start, "hour", false, false)} a ${sqlDateFormat(end, "hour", false, false)}`;
    }

    if (filterType === 3 && officeSelected) {
      const oficina = listOffice.find(o => o.IdSucursal === officeSelected);
      return `INGRESOS GENERADOS EN LA AGENCIA: ${oficina ? oficina.Codigo + ' ' + oficina.NombreSucursal : ''}\nCORRESPONDIENTE DEL ${fechaDesde} al ${fechaHasta}${horas}`;
    }
    if (filterType === 2 && selectedProvince) {
      const provincia = provinces.find(p => p.value === selectedProvince);
      return `INGRESOS GENERADOS EN LA PROVINCIA DE: ${provincia ? provincia.label : ''}\nCORRESPONDIENTE DEL ${fechaDesde} al ${fechaHasta}${horas}`;
    }
    if (filterType === 1) {
      return `INGRESOS GENERADOS A NIVEL NACIONAL\nCORRESPONDIENTE DEL ${fechaDesde} al ${fechaHasta}${horas}`;
    }
    return '';
  };

  useEffect(() => {
          handleGetListOffices();
    
  }, []);

  useEffect(() => {
    if (user.roleId >= 4) {
      handleGetListProvinces();
    }
  }, [user.roleId]);

  useEffect(() => {
    if ([2,3].includes(user.roleId)) {
      setFilterType(3);
    } else if ([4,5,6].includes(user.roleId)) {
      setFilterType(2); 
    } else if (user.roleId >= 7) {
      setFilterType(1);
    } else {
      setFilterType(0);
    }
  }, [user.roleId]);

  return ( <>
    <div className="dashboardCard text-left" style={{ color: "black", marginBottom: "20px" }}>
        <div className="d-flex justify-content-between" style={{ gap: 20 }}>
            <div className="d-flex align-items-center">
                <RiHomeOfficeFill size={20} className="mr-2" />
                <h5 className="mb-0">Búsqueda Reporte de Comisión y transmisión</h5>
            </div>
        </div>
    </div>
    <div className="dashboardCard p-3" style={{ color: "black" }}>
     <div className="d-flex justify-content-between flex-wrap mb-2">
            <p className="mb-0">Filtros de búsqueda</p>
        </div>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="row" style={{ flex: 0.5}}>
          {showFilterTypeSelector && (
            <div className="col-12 col-md-6 input-group text-left mb-3">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black", borderRadius: "6px 0 0 6px" }}>
                        <BsBuilding className="mr-2" size={18} /> Tipo de Reporte
                    </span>
                </div>
                <SelectSearch 
                options={filterTypeList} 
                nameInput="filterType" 
                setValue={handleSelect} 
                value={filterType} />
            </div>
          )}
 
          {/* Filtro de provincia */}
          {showProvinceFilter && (
            <div className="col-12 col-md-6 input-group text-left mb-3">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black", borderRadius: "6px 0 0 6px" }}>
                        <BsBuilding className="mr-2" size={18} /> Provincia
                    </span>
                </div>
                <SelectSearch options={provinces} nameInput="province" setValue={handleSelect} value={selectedProvince} />
            </div>
          )}
 
          {/* Filtro de estafeta */}
          {showOfficeFilter && (
               (renderOriginSelectOffice("office", "Estafeta"))
          )}
 
          {/* Filtro de rango de fechas */}
          <div className="col-12 col-md-6 input-group text-left mb-3 customDatePickerWidth" >
           <div className="input-group-prepend d-flex align-items-center">
                <span className="input-group-text text-bold input-label" style={{ backgroundColor: "#FBD825", color: "black" }}>
                    <BsCalendar2Check className="mr-2" size={18} /> Rango de Fechas
                </span>
            </div>
            <DatePicker
                type="text"
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                name="dateRange"
                isClearable={true}
                placeholderText="Selecciona un rango de fechas"
                className="form-control input-field w-100"
                dateFormat="dd/MM/yyyy"
                style={{ flexGrow: 1, width: "100%", minWidth: "300px" }}
            />
          </div>
 
          {/* Filtro de rango de horas */}
          <div className="col-12 col-md-6 input-group text-left mb-3" style={{ width: "100%" }} >
            <div className="input-group-prepend d-flex align-items-center ">
                <span className="input-group-text text-bold input-label pb-1" style={{ backgroundColor: "#FBD825", color: "black" }}>
                    <BsClock className="mr-2" size={18} /> Rango de Horas
                </span>
            </div>
            <CustomProvider locale={locale.value}>
            <TimeRangePicker 
                format="hh:mm aa"
                showMeridiem 
                className="input-field w-100 "
                value={time}
                onChange={(val) => setTime(val || [])}
                placeholder="Selecciona un rango de horas"
            />
            </CustomProvider>
        </div>
        </div>
        <div className="d-flex justify-content-center mt-3" style={{ gap: '12px' }}>
          <button type="submit" className="btn btn-blue" disabled={isLoading || !canSearch()}> <BsSearch /> Buscar</button>
          <button type="button" className="btn btn-secondary" onClick={handleReset}> <TbZoomReset size={20} /> Reiniciar</button>
        </div>
      </form>
 

    </div>

      {hasSearched && results.length > 0 && !isLoading && (
        <div className="dashboardCard p-3" style={{ color: "black" }}>
          <div
            style={{
              background: '#f6f6f6',
              border: '1px solid #e0e0e0',
              borderRadius: '6px',
              padding: '8px 12px',
              marginBottom: '14px',
              whiteSpace: 'pre-line',
              textAlign: 'center',
              fontWeight: 500,
              fontSize: '1rem',
              color: '#333',
              letterSpacing: '0.1px',
              lineHeight: 1.4,
              boxShadow: 'none',
              display: 'block',
            }}
          >
            {getReportHeaderText()}
          </div>
          <DataTable 
            columns={columns} 
            data={results} 
            exportableColumns={columns.filter(column => column.exportable)}
            exportExcel
            exportPdf
            filename='reporte-comisiones-transmisiones'
            nameReport='REPORTE COMISIONES Y TRANSMISIONES'
            includeTotals={true}
            customHeader={getReportHeaderText()}
            IdSucursal={officeSelected}
            logTypeExcel={25}
            logTypePdf={26}
            IdProvincia={selectedProvince}
         />
            </div>

        )}

      {isLoading && (
        <div className="dashboardCard d-flex justify-content-center align-items-center" style={{ color: "black" }}>
        <div className="text-center ">
            <Spinner type={2} size={40} />
            </div>
        </div>
        )}
    </>);
};
 
export default SearchCommissionReport;